export default (userCountry) => {
    if (userCountry === 'CA') {
        return 'KM';
    }
    return 'miles';
};
